/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import { GroupThemedContentPanelWithFullHeader } from 'components/common/ContentPanel';
import { PasswordInput } from 'components/common/TextInput';
import Form from 'components/common/Form';
import PasswordStrengthMeter from 'components/features/PasswordStrengthMeter';
import { CancelSubmitFormControls } from '../../../common/FormControls/CancelUpdateFormControls';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';
import { LocalText } from 'components/pages/common/LocalText';

const SetPassword = (props) => (
  <GroupThemedContentPanelWithFullHeader isFixedWidth titlePhrase={props.titlePhrase} subTitle={<LocalText text={props.organizationName}/>}>
    <WhiteCardWithWidePadding>
      <Form>
        <PasswordInput
          value={props.password}
          onFocus={() => {
            props.setIsPasswordStrengthVisible && props.setIsPasswordStrengthVisible(true);
            props.onFocus();
          }}
          onBlur={() => {
            props.setIsPasswordStrengthVisible && props.setIsPasswordStrengthVisible(false);
          }}
          onChange={props.onChangePassword}
          isInvalid={false}
          name="password"
          label={<FormattedMessage id="setPwd.password.field.label" />}
        />

        <div style={{ height: '40px' }}>
        {
          props.isPasswordStrengthVisible && <PasswordStrengthMeter value={props.passwordStrength} />
        }
        </div>


        <CancelSubmitFormControls
          onCancel={props.goBack}
          onSubmit={props.submitPasswordChange}
          isSubmitDisabled={props.isPasswordInvalid}
        />

      </Form>
    </WhiteCardWithWidePadding>
  </GroupThemedContentPanelWithFullHeader>
);

export default SetPassword;